module.exports = __webpack_public_path__ + "media/images/page/top/top_icon_map-668b5a455b75fe86bcfcbfe5d0969d1b.png";